module.exports = __webpack_public_path__ + "static/logo-nom-e15170018092c1149daef982120747ea.png";